import React, { useContext } from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Container } from '@comparethemarketau/manor-grid';

import { FooterDisclaimer } from './common/footer_disclaimer';
import { SecurityLogo } from './common/security_logo';
import { FooterCopyright } from './common/footer_copyright';

const useStyles = createUseStyles((theme) => ({
    container: {
        backgroundColor: theme.colors.white,
        display: 'flex',
        flexDirection: 'column',
        fontSize: theme.fontSize.xs
    },
    securityLogo: {
        alignSelf: 'center',
        marginBottom: theme.spacing[16]
    },
    disclaimer: {
        marginBottom: theme.spacing[28]
    },
    copyright: {
        alignSelf: 'center'
    }
}));

const FooterManorXs = () => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className={classNames(classes.container)}>
            <Container padding={['16', '16', '16', '16']}>
                <SecurityLogo className={classes.securityLogo} />
                <FooterDisclaimer className={classes.disclaimer} />
                <FooterCopyright className={classes.copyright}  />
            </Container>
        </div>
    );
};

export { FooterManorXs };
